<template>
    <loading v-model:active="isLoading" color="#00567e" :is-full-page="fullPage"/>
    <MultiStepArrow v-show="step !=1 && step !=7" :tabs="tabs" :selected="steps.indexOf(step)" /> 
    <keep-alive>
        <component 
            ref="currentStep"
            :is="currentStep" 
            :headers="headers" 
            :showPrice=false 
            :contents="contents" 
            :categories="categories" 
            @update="processStep"
            @next="next"
            @checkout="next"
            :days="days" 
            :times="times" 
            :storeHours="form.storeHours" 
            :physicalStore="form.physicalStore"
            :byAppointment="form.byAppointment" 
            :formData="form"
            :countryCode="country.code"
            classes="settings-layout details-layout"
            :littManager="form.littManager"
            :littlandReferrer="form.littlandReferrer"
            :userCreated="userCreated"
            :planStartDate="form.planStartDate"
            :merchant="merchant"
            :subscriptionplans="subscriptionplans"
            :subscriptionvouchers="subscriptionvouchers"
            :countrycode="countrycode"
            :currencycode="currencycode"
        >
        </component>
    </keep-alive>   

    <div v-show="step == 7" class="settings-layout details-layout">
        <div class='business-details-success'>
            <div>
                <img :src="form.logo ? form.logo : ''" alt="">
            </div>
            <h4 style="text-align:center;">Your business details have been added successfully.</h4>
            <a href="dashboard" class="btn first-btn">Go to Dashboard</a>
            <a href="create_notification_ar" class="btn first-btn">Create AR Deal</a>
            <a href="download-litt-business-kit" class="btn first-btn">Business Kit</a>
            <div class="qr-codes-container" v-show="false">
                <div class="qr-code-wrapper">
                    <a href="#" @click="saveCapture('capture1', 'LITT_QR_code')" class="btn first-btn">Download Card</a>
                    <div id="capture1" class="capture-option">
                        <img class="big-qr-image" src="/images/qr-codes/big_qr_code.jpg" alt="">
                        <div class="big-qr-code-holder">
                            <img class="big-qr-code" :src="qrcode" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-footer" v-show="step != 7">
        <button v-if="step > 1 && step != 6" @click="prev()" class="register-step-button">Prev</button>
        <button v-if="step == 2" @click="this.userCreated ? next() : createUser()" class="register-step-button">{{ this.userCreated ? 'Next' : 'Create & Next'}}</button>
        <button v-if="step ==3 || (step == 4 && (!this.merchant || this.form.businessType == 'Gold Partner'))" @click="next()" class="register-step-button">Next</button>
        <button v-if="step == 5" @click="this.form.businessType == 'Brand Partner' ? submitForm() : next()" class="register-step-button">{{ this.form.businessType == 'Brand Partner' ? 'Submit' : 'Payment method' }}</button>
        <button v-if="step == 4 && this.merchant && this.form.businessType == 'Brand Partner'" @click="submitForm()" class="register-step-button">Submit</button>
        <!-- <button v-if="step == 6" :disabled="!completedStep" @click="this.$refs.submitForm()" class="register-step-button">Submit</button> -->
    </div>
</template>
<script>
    import PricingPlan from '../PricingPlan.vue';
    import MultiStepArrow from '../../MultiStepArrow.vue';
    //import AutoCompleteLocation from '../../AutoCompleteLocation.vue';
    import CreateUser from './CreateUser.vue'
    import StoreHours from '../../StoreHours.vue';
    import StoreDetails from './StoreDetails.vue';
    import BillingInfo from './BillingInfo.vue';
    import LITTPay from './LITTPay.vue';
    import Checkout from './Checkout.vue';
    import axios from "axios";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default { 
        name: "BusinessDetails",
        components: { PricingPlan, MultiStepArrow, StoreHours, StoreDetails, BillingInfo, LITTPay, Loading, Checkout, CreateUser },
        props: ['country', 'categories', 'times', 'days', 'qrcode', 'url', 'merchant', 'stringkeystring', 'countrycode', 'currencycode', 'subscriptionplans'],
        data() {
            return {
                tabTypes: [
                    {
                        'name': "Gold Partner",
                        'tabs': this.merchant ? ['Partner Plan', 'Profile Info', 'Store Details', 'Billing Information', 'Check out'] : ['Partner Plan', 'Create User', 'Profile Info', 'Store Details', 'Billing Information', 'Check out'],
                        'steps': this.merchant ? [1,3,4,5,6] : [1,2,3,4,5,6]
                    },
                    {
                        'name': "Brand Partner",
                        'tabs': this.merchant ?['Partner Plan', 'Profile Info', 'Billing Information'] : ['Partner Plan','Create User', 'Profile Info', 'Billing Information'],
                        'steps': this.merchant ? [1,3,5] : [1,2,3,5]
                    }
                ],
                userCreated: false,
                step:  1,
                steps: (this.merchant ? [1,3,4,5,6] : [1,2,3,4,5,6]),
                components: ['PricingPlan', 'CreateUser', 'StoreDetails', 'StoreHours', 'BillingInfo', 'Checkout'],
                headers: [{"name": "Gold Partner"}, {"name": "Brand Partner"},],
                contents: [
                    {"statement": "Accept LITT Pay", "content": ['<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-times mr-2 text-primary"></i>']},
                    {"statement": "Advertise on LITT", "content": ['<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-check mr-2 text-primary"></i>']},
                    {"statement": "Create voucher and coupons on LITT", "content": ['<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-times mr-2 text-primary"></i>']},
                    {"statement": "Appear in Stores Map", "content": ['<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-times mr-2 text-primary"></i>', '<i class="fa fa-times mr-2 text-primary"></i>']},
                    {"statement": "Appear in Stores Listing", "content": ['<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-times mr-2 text-primary"></i>']},
                    {"statement": "Store Profile Page", "content": ['<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-check mr-2 text-primary"></i>', '<i class="fa fa-check mr-2 text-primary"></i>']}
                ],
                tabs: ['Partner Plan', 'Create User', 'Profile Info', 'Store Details', 'Billing Information', 'Check out'],
                completedStep: false,
                isLoading: false,
                fullPage: true,
                form:{
                    selectedPlanId:"",
                    selectedPlan:"",
                    byCreditCard: true,
                    physicalStore: true,
                    yearlyPlan: "",
                    monthlyPlan: "",
                    defaultFreeTrial: 0,
                    joiningFee: 0,
                    planFee: 0,
                    planStartDateDisplay: "",
                    planStartDate: "",
                    planEndDate: "",
                    originalJoiningFee: 0,
                    originalPlanFee: 0,
                    originalPlanStartDateDisplay: "",
                    originalPlanStartDate: "",
                    originalPlanEndDate: "",
                    businessType: "",
                    storeName: this.merchant ? this.merchant.name : "",
                    userName: "",
                    mobile: "",
                    password: "",
                    confirmPassword: "",
                    littManager: (new URLSearchParams(window.location.search)).get('manager') ? (new URLSearchParams(window.location.search)).get('manager') : '',
                    littlandReferrer: (new URLSearchParams(window.location.search)).get('referrer') ? (new URLSearchParams(window.location.search)).get('referrer') : '',
                    category: "",
                    firstName: "",
                    lastName: "",
                    storeDescription: "",
                    storeEmail: "",
                    storeAreaPhone: "",
                    storePhone: "",
                    website: "",
                    abn: "",
                    ein: "",
                    byAppointment: false,
                    logo: "",
                    downloadedQR: false,
                    accountName: "",
                    bsb: "",
                    accountNo: "",
                    storeHours: {
                        "Monday": {
                            "start_Monday" : "09:00",
                            "end_Monday": "17:00",
                            "closed_Monday": false
                        },
                        "Tuesday": {
                            "start_Tuesday" : "09:00",
                            "end_Tuesday": "17:00",
                            "closed_Tuesday": false
                        },
                        "Wednesday": {
                            "start_Wednesday" : "09:00",
                            "end_Wednesday": "17:00",
                            "closed_Wednesday": false
                        },
                        "Thursday": {
                           "start_Thursday" : "09:00",
                            "end_Thursday": "17:00",
                            "closed_Thursday": false
                        },
                        "Friday": {
                            "start_Friday" : "09:00",
                            "end_Friday": "17:00",
                            "closed_Friday": false
                        },
                        "Saturday": {
                            "start_Saturday" : "09:00",
                            "end_Saturday": "17:00",
                            "closed_Saturday": false
                        },
                        "Sunday": {
                            "start_Sunday" : "09:00",
                            "end_Sunday": "17:00",
                            "closed_Sunday": false
                        }
                    },
                    countryCode: this.merchant ? this.country.code : this.countrycode,
                    country: "",
                    address1: "",
                    zip: "",
                    suburb: "",
                    state: "",
                    billingFirstName: "",
                    billingLastName: "",
                    billingCountryCode: "",
                    billingCountry: "",
                    billingAddress1: "",
                    billingZip: "",
                    billingSuburb: "",
                    billingState: "",
                    billingEmail: "",
                    billingAreaPhone: "",
                    billingPhone: "",
                    cardHolder: "",
                    stripeKeyString: this.stringkeystring
                }
            }
        },
        methods: {
            prev() {
                this.completedStep = true;

                let skip = 1;

                if (this.steps[this.steps.indexOf(this.step)] == 5 && !this.form.physicalStore) {
                    skip = 2;
                }

                this.step = this.steps[this.steps.indexOf(this.step) - skip];

                window.scrollTo(0,0);
            },
            next() {
                let skip = 1;

                if (this.steps[this.steps.indexOf(this.step)] == 3 && 
                !this.form.physicalStore && this.form.businessType == 'Gold Partner') {
                    skip = 2;
                }

                if(this.completedStep){

                    if (this.step == 6) {
                        this.isLoading = false;
                        this.step = 7;
                    } else {
                        this.step = this.steps[this.steps.indexOf(this.step) + skip];
                    }
                } else {
                    this.$refs.currentStep.v$.$touch();
                }
           
                this.$nextTick(() => {
                    this.$refs.currentStep.submit();
                })

                window.scrollTo(0,0);

            },
            processStep(stepData){
                Object.assign(this.form, stepData.data)
                this.completedStep = stepData.valid;
                if(stepData.data.hasOwnProperty('businessType') && stepData.valid){
                    this.tabs = this.tabTypes.filter(tabTypes => tabTypes.name == stepData.data.businessType)[0].tabs
                    this.steps = this.tabTypes.filter(tabTypes => tabTypes.name == stepData.data.businessType)[0].steps
                }
            },
            async createUser(){
                if(this.completedStep){
                    this.isLoading = true;

                    await axios.post('register', this.form)
                    .then((response) => {
                        if (response.data.status == 'true') {
                            this.userCreated = true;

                            this.isLoading = false;
                            this.step = 3;
                        } else {
                            console.log(response.data.error);
                        }
                    })
                    .catch(function (error) {
                        this.isLoading = false;
                        console.log(error);
                    })
                } else {
                    this.$refs.currentStep.v$.$touch();
                }
                
                this.$nextTick(() => {
                    this.$refs.currentStep.submit();
                });

                window.scrollTo(0,0);

            },
            async submitForm(){
                if (this.form.businessType == 'Brand Partner' && !this.$refs.currentStep.valid()) {
                    this.$refs.currentStep.v$.$touch();
                    return false;
                }
                this.isLoading = true;
                await axios.post('save-business-details', this.form)
                .catch(function (error) {
                    this.isLoading = false;
                    console.log(error);
                    return false;
                }).then( (res) => {
                    this.isLoading = false;
                    if (this.form.businessType == 'Brand Partner') {
                        this.step = 7;
                    }
                    return true;
                } );
            },
            saveCapture(element, filename){
                this.downloadedQR = true;
                function adjust_view(callback){
                    $('.qr-download-loader').addClass('active');
                    
                    $('.capture-option').each(function(){
                        $(this).parents().addClass('overflow-canvas');
                    });
                    
                    $('#capture1').width('1754px');                    
                    window.scrollTo(0, 0);
                    callback.apply(this,[]);
                }
            
                function download_qr(callback){
                    html2canvas(document.getElementById(element), {
                        useCORS: true,
                        scale: 1, 
                        logging: true
                    }).then(function(canvas) {
                        download(canvas.toDataURL("image/jpg"), filename);
                    }).then(function(){
                        $('#capture1').width('');
                    
                        $('.capture-option').each(function(){
                            $(this).parents().removeClass('overflow-canvas');
                        });

                        $('.qr-download-loader').removeClass('active');                        
                        console.log("reseting view");
                    });

                    callback.apply(this,[]);
                }
                
                adjust_view(function(){
                        console.log("preparing view for download");
                        setTimeout(function(){
                            download_qr(function(){
                                console.log("downloading QR Code");
                            });
                        }, 1000);
                });

                function download(url, filename){
                    var a = $("<a style='display:none' id='js-downloder'>")
                    .attr("href", url)
                    .attr("download", filename + ".jpg")
                    .appendTo("body");

                    a[0].click();
                    a.remove();
                }
            },
            leaving: function (e) {
                //e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                // Chrome requires returnValue to be set
                if(this.step != 5){
                    e.returnValue = "";
                }
            },
            showLoading(){
                this.isLoading = true;
            },
            hideLoading(){
                this.isLoading = false;
            }
        },
        computed:{
            currentStep(){
                return this.components[this.step - 1];
            }
        },
        mounted() {
            if (this.merchant) {
                this.userCreated = true;
            }
            window.addEventListener('beforeunload', this.leaving);
        },
        provide() {
            return {
                prev: this.prev,
                next: this.next,
                submitForm: this.submitForm,
                showLoading: this.showLoading,
                hideLoading: this.hideLoading,
                countryCode: this.form.countryCode
            }
        }
    };
</script>